import { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Buttons, FlexContainer } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { signUpAction } from 'Store/modules/auth/actions';
import { emailSelector } from 'Store/modules/auth/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import PasswordValidation from 'Components/PasswordValidation';
import { isValidPassword } from 'Utils/security';
import * as Styled from './styles';

const Form = (): JSX.Element => {
  const dispatch = useDispatch();
  const [password, setPassword] = useState('');
  const email = useSelector(emailSelector);
  const { t } = useTranslation(locizeNS.AUTH);
  const isFormValid = useMemo(() => isValidPassword(password), [password]);

  const onSubmit = (e): void => {
    e.preventDefault();
    dispatch(signUpAction({ password, email }));
  };

  const handleOnChange = (value: string): void => {
    setPassword(value);
  };

  return (
    <form onSubmit={onSubmit}>
      <FlexContainer direction="column" gap="dimension_24">
        <Styled.Input
          label={t('Auth.signIn.labelPassword')}
          id="password"
          name="password"
          type="password"
          hasBorder
          value={password}
          onChange={handleOnChange}
          testID="password"
        />
        <PasswordValidation password={password} />
        <Buttons.Classic
          label={t('common:Button.continue')}
          type="submit"
          testID="signUpSubmit"
          mode="primary"
          size="l"
          fullWidth
          disabled={!isFormValid}
        />
      </FlexContainer>
    </form>
  );
};

export default Form;
